import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

const ProtectedRoutes = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  var { dev } = useSelector((state) => state.dev);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (isLoggedIn === false || dev?.verified === false) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoutes;
